<template>
  <div>
    <head-nav-bar title="收银台" :fixed="true" />
    <div class="mt-header-nav">
      <van-row style="padding: 5px 10px;">
        <van-col span="12" style="color: #999999;">
          消费金额：<span style="color:red">
            {{ orderInfo.TotalAmount }}
          </span>
        </van-col>
        <van-col span="12" style="color: #999999;">
          已收金额：<span style="color:red">
            {{ orderInfo.AlreadyPayAmount }}
          </span>
        </van-col>
      </van-row>

      <pay
        ref="pay"
        :isSelectRoom="true"
        :selectRoomArr="selectRoomArr"
        @submit="onSubmit"
      />
    </div>
  </div>
</template>

<script>
import orderApi from "../../api/order.js";
import pay from "./Pay";
import { jump } from "../../utils/common";
import { mapState } from "vuex";
import { Row, Col, Checkbox, CheckboxGroup, Button, Notify } from "vant";

export default {
  name: "OrderCashDesk",
  components: {
    pay,
    [Row.name]: Row,
    [Col.name]: Col,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
  },
  data() {
    return {
      orderId: null,
      orderInfo: {},
      payMoney: "",
      selectRoomArr: [],
    };
  },
  model: {},
  created() {
    this.orderId = this.$route.query.id;
    this.init();
  },
  mounted() {},
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  watch: {},
  methods: {
    init() {
      orderApi.getOrderDetail({ id: this.orderId }).then(res => {
        this.orderInfo = res.Data;
        this.getRoomByStatus();
      });
    },
    //获取在住房间显示
    getRoomByStatus() {
      const roomList = [];
      this.orderInfo.Details.forEach(item => {
        if (
          item.OrderStatus == 1 ||
          item.OrderStatus == 0 ||
          item.OrderStatus == 3
        ) {
          item.Checked = false;
          roomList.push({ ...item });
        }
      });
      this.selectRoomArr = roomList;
    },
    onSubmit(payInfo) {
      if (Number(payInfo[0].Money) == 0) {
        Notify("请填写金额");
        return false;
      }
      if (!payInfo[0].AccountItemId) {
        Notify("请选择付款方式");
        return false;
      }
      if (payInfo[0].RoomId) {
        let room = this.orderInfo.Details.find(
          p => p.RoomId == payInfo[0].RoomId,
        );
        payInfo[0].GuestId = room.Persons[0].Id;
      } else {
        payInfo[0].GuestId = this.selectRoomArr[0].Persons[0].Id;
      }
      payInfo[0].OrderId = this.orderId;
      orderApi.addPay(payInfo).then(() => {
        Notify({ message: "操作成功", type: "success" });
        jump("OrderDetail", { id: this.orderId });
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
